import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'
import { AppBar, Menu, MenuItem, Toolbar, IconButton, Typography } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import AccountCircle from '@material-ui/icons/AccountCircle'
import { Logout } from './../../actions/cognito'
import './styles.css'

const styles = theme => ({
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
    flexGrow: 1
  }
})

class Navigation extends Component {
    constructor(props) {
      super(props)
      this.handleMenuClick = this.handleMenuClick.bind(this)
      this.handleDashboardClick = this.handleDashboardClick.bind(this)
      this.state = {
        menuVisible: false,
        userMenuVisible: false
      }
    }
    
    static get propTypes() {
        return {
          title: PropTypes.string.isRequired,
          history: PropTypes.object.isRequired
        }
    }

    componentDidMount() {
    }

    render() {
        const {classes} = this.props
        return (
            <div className='components-navigation'>
                <AppBar position='static'>
                  <Toolbar>
                    <IconButton color="inherit" aria-label="Menu" className={classes.menuButton} onClick={(evt) => this.handleMenuClick(evt.currentTarget)} >
                      <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" color="inherit" className={classes.title}>
                      {this.props.title} - Run The Mare Nostrum
                    </Typography>
                    <IconButton
                        aria-haspopup="true"
                        onClick={(evt) => this.handleUserMenuClick(evt.currentTarget)}
                        color="inherit"
                      >
                      <AccountCircle />
                    </IconButton>
                  </Toolbar>
                </AppBar>
                <Menu open={this.state.menuVisible} onClose={() => this.setState({ menuVisible: false })} anchorEl={this.state.menuAnchor}>
                    <MenuItem onClick={() => this.handleDashboardClick()}>Dashboard</MenuItem>
                    <MenuItem onClick={() => this.handleMyProfileClick()}>My Profile</MenuItem>
                    <MenuItem onClick={() => this.handleMyTeamsClick()}>My Teams</MenuItem>
                </Menu>
                <Menu open={this.state.userMenuVisible} onClose={() => this.setState({ userMenuVisible: false })} anchorEl={this.state.userMenuAnchor}>
                    <MenuItem onClick={() => this.handleMyProfileClick()}>My Profile</MenuItem>
                    <MenuItem onClick={() => this.handleLogoutClick()}>Logout</MenuItem>
                </Menu>
            </div>
        )
    }

    handleMenuClick (anchor) {
      this.setState({ 
        menuVisible: !this.state.menuVisible,
        menuAnchor: anchor
      })
    }

    handleUserMenuClick (anchor) {
      this.setState({ 
        userMenuVisible: !this.state.userMenuVisible,
        userMenuAnchor: anchor
      })
    }

    handleDashboardClick () {
      this.props.history.push('/')
    }

    handleMyProfileClick () {
      this.props.history.push('/profile/me')
    }

    handleMyTeamsClick () {
      this.props.history.push('/teams/')      
    }

    handleLogoutClick () {
      this.props.logout().then(() => {
        // hard refresh to clear state
        window.location.href = '/login'
      })
    }
}

const mapState = (state) => ({ })

const mapDispatch = (dispatch) => {
  return {
    logout: (userId) => Logout()(dispatch),
  }
}

export default connect(mapState, mapDispatch)(withRouter(withStyles(styles)(Navigation)))
